import JSURL from 'jsurl';
import getConfig from 'next/config';

/**
 * @param {JobAdRecommendationsOptions} options
 * @returns {Promise<JobAdRecommendationsResult>}
 */

function get(options) {
  const { publicRuntimeConfig } = getConfig();

  /**
   * @type {RecommendationsAdApiHeaders}
   */
  const headers = {
    Accept: 'application/json',
    'Accept-Language':
      (options && options.language) || publicRuntimeConfig.defaultLanguage,
  };

  let fetchUrl = `${publicRuntimeConfig.recommendationsBaseUrl}`;

  if (options?.type === 'JOB_AD' && options.config) {
    fetchUrl += `?type=${options.type}${
      options.landingPageCode
        ? `&landingPageCode=${options.landingPageCode}`
        : ''
    }&config=${JSURL.stringify(options.config)}`;
  }

  return fetch(fetchUrl, {
    headers,
  }).then((res) => {
    return res.json();
  });
}

export default {
  get,
};
